import React from 'react';

export const PageTitleUnderlineExpression = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="325"
    height="24"
    className={className}
  >
    <path
      d="M 9.613 5.801 C 87.132 9.176 198.897 7.412 317.508 5.801"
      fill="transparent"
      strokeWidth="4"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
    ></path>
  </svg>
);
